export const decodeBase64String = (base64encodedString: string): string => {
  return Buffer.from(base64encodedString, "base64").toString("utf-8");
};
